import { NavItem } from '@/pages/common/navigation/types'

export const data: NavItem[] = [
  {
    id: 'tasks',
    title: 'Банк заданий',
    icon: 'tasks',
    children: [{ title: 'Задания для уроков', link: 'lesson-tasks-list' }],
  },
  {
    id: 'learning',
    title: 'Обучение',
    icon: 'book',
    children: [
      { title: 'Уроки', link: 'lessons-list' },
      { title: 'Курсы', link: 'courses-list' },
      { title: 'Заявки', link: 'courses-application-list' },
    ],
  },
  {
    id: 'results',
    title: 'Результаты',
    icon: 'statistics',
    children: [
      {
        id: 'results-courses',
        title: 'Курсы',
        isSubmenu: true,
        children: [
          { title: 'Курсы - Общие', link: 'results-courses-list' },
          { title: 'Курсы - По ученикам', link: 'results-courses-student-list' },
          { title: 'Управление проверкой урока', link: 'results-courses-check-list' },
        ],
      },
    ],
  },
  {
    id: 'users',
    title: 'Пользователи',
    icon: 'user',
    children: [
      { title: 'Сотрудники', link: 'employers-list' },
      { title: 'Ученики', link: 'users-list' },
      { title: 'Группы пользователей', link: 'groups-list' },
    ],
  },
  {
    id: 'callback',
    title: 'Обратная связь',
    icon: 'callback',
    children: [{ title: 'Комментарии к урокам', link: 'comments-on-lessons-list' }],
  },
  {
    id: 'catalog',
    title: 'Справочник',
    icon: 'folder',
    children: [
      { title: 'Темы', link: 'themes-list' },
      { title: 'Предметы', link: 'subjects-list' },
    ],
  },
  {
    id: 'content',
    title: 'Контент',
    icon: 'display',
    children: [
      { title: 'Новости', link: 'news-list' },
      { title: 'FAQ', link: 'faq-list' },
    ],
  },
]
